import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import logger from "lib/logger";
import "./index.scss";
import AccountInfo from "../../components/AccountInfo";
import { selectAccount } from "lib/redux/selectors";
import ResourceManage from "../../components/ResourceManage";

interface Props {
  account: {
    address: string;
    accountInfo: any;
    resource: any;
  };
}

class Page extends Component<Props, any> {
  componentDidMount() {
    logger().track("to_home");
  }

  render() {
    return (
      <div className="home" id="home">
        <AccountInfo
          account={this.props.account}
          showResourceManagement={false}
          stakingVersion={1}
        />
        <ResourceManage account={this.props.account} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: selectAccount(state),
  };
};

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));
